import { useState, useEffect } from 'react';
import api from "../../../../services/api";

/**
 * 아카이브 > 회고록 > 상세
 * 회고록 상세 (단락) api 호출 hook
 */
const useApiRecords = (book_id, tocId) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        // API 호출
        const fetchBiographyRecords = async () => {
            try {
                const response = await api.get(`/get_tocs_with_tocrecords_by_book_id/${book_id}`);
                if (response?.data?.data === false) {
                    throw new Error("Invalid response format");
                }
                const initialData = response.data.data.find(item => item.toc_id === tocId);
                const formattedData = {
                    book_id: initialData.book_id,
                    toc_id: initialData.toc_id,
                    toc_title: initialData.toc_title,
                    page_start: initialData.page_start,

                    records: initialData.records_with_person.map((record) => ({
                        tocrecord_id: record.tocrecord_id,
                        record_text: record.record_text,
                        page_start: record.page_start,
                        persons: record.persons,
                    }))
                };
                formattedData.records.sort((a, b) => parseInt(a.page_start) - parseInt(b.page_start));
                setData(formattedData);
            } catch (error) {
                console.error("Failed to fetch book details", error);
            }
        };

        fetchBiographyRecords();
    }, [book_id, tocId]);

    return data;
};

export default useApiRecords;
